export const DeliveryStatus = {
  HANDDELIVERY: 'HANDDELIVERY',
  DELIVERED: 'DELIVERED',
  PENDING: 'PENDING',
  PICKED_UP: 'SHIPPED',
};
